import request from '@/utils/http'

export function offlineDeviceNear(data) {
  return request({
    url: '/business/offline/device/near',
    method: 'post',
    data
  })
}
